export default __webpack_public_path__ + "65fa82b16a7958684ad05439f08a84d4.svg";